var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"bottomLeft"}},[_c('div',{staticClass:"bg-color-black"},[_vm._m(0),_c('div',[_c('BottomLeftChart')],1)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex pt-2 pl-2"},[_c('div',{staticClass:"d-flex"},[_c('span',{staticClass:"text mx-2"},[_vm._v("天气7日报")])])])
}]

export { render, staticRenderFns }